export const CREATE_NEW_API_TABS = [
  {
    label: 'Core Settings',
  },
  {
    label: 'Data Sources',
  },
  {
    label: 'Playground',
  },
];

export const EDIT_TABS = [
  { label: 'General' },
  { label: 'Data Sources' },
  { label: 'Schema and Limits' },
  { label: 'IP Filtering' },
  { label: 'Additional Resolvers' },
  { label: 'Cache Settings' },
];
export const VIEW_TABS = [{ label: 'Playground' }, { label: 'Schema' }];
